import { extractNumericFromFilename } from "../utils/extractNumericFromFilename";

// __________ key와 order에 따라 날짜, 파일명, 텍스트 필드를 정렬하는 메인 함수__________
export function dataSorting(data, key, order) {
  switch (key) {
    case "uploaded_at":
      return order === "asc" ? sortByDateAsc(data) : sortByDateDesc(data);
    case "file_name":
      return order === "asc"
        ? sortByFilenameNumericAsc(data)
        : sortByFilenameNumericDesc(data);
    default:
      return sortByTextField(data, key, order);
  }
}

// __________최신 날짜 순으로 정렬__________
export function sortByDateDesc(data) {
  const temp = [...data];
  temp.sort((a, b) => {
    const dateA = new Date(a.uploaded_at);
    const dateB = new Date(b.uploaded_at);

    return dateB - dateA;
  });
  return temp;
}

// __________오래된 날짜 순으로 정렬 __________
export function sortByDateAsc(data) {
  const temp = [...data];
  temp.sort((a, b) => {
    const dateA = new Date(a.uploaded_at);
    const dateB = new Date(b.uploaded_at);

    return dateA - dateB;
  });
  return temp;
}

// __________파일명을 숫자로 간주해 내림차순 정렬 (파일 기준 최신 날짜 순으로 정렬)__________
export function sortByFilenameNumericDesc(data) {
  return [...data].sort((a, b) => {
    const numA = extractNumericFromFilename(a.file_name);
    const numB = extractNumericFromFilename(b.file_name);
    return numB - numA;
  });
}

// __________파일명을 숫자로 간주해 오름차순 정렬 __________
export function sortByFilenameNumericAsc(data) {
  return [...data].sort((a, b) => {
    const numA = extractNumericFromFilename(a.file_name);
    const numB = extractNumericFromFilename(b.file_name);
    return numA - numB;
  });
}
//__________시간 문자열 숫자로 간주해 오름차순 정렬 __________
export function sortByTimeAsc(data) {
  return [...data].sort((a, b) => a.seconds - b.seconds);
}

function toSortableText(value) {
  if (value == null) return "";
  return String(value);
}

// __________한글 정렬 가나다순 오름차순 / 내림차순 정렬 __________
export function sortByTextField(data, key, order) {
  return [...data].sort((a, b) => {
    const valA = toSortableText(a?.[key]);
    const valB = toSortableText(b?.[key]);

    return order === "asc"
      ? valA.localeCompare(valB, "ko")
      : valB.localeCompare(valA, "ko");
  });
}

export function sortByUploadedAtDescThenFilenameAsc(data) {
  return [...data].sort((a, b) => {
    const ta = a.uploaded_at;
    const tb = b.uploaded_at;

    // 1) 등록일(분 단위) 최신순
    if (tb !== ta) return tb - ta;

    // 2) 같은 분이면 파일명 숫자 오름차순 (오래된 날짜값이 먼저)
    const na = extractNumericFromFilename(a.file_name);
    const nb = extractNumericFromFilename(b.file_name);
    if (na !== nb) return na - nb;

    // 3) 완전 동일하면 파일명 사전식 보조키
    return toSortableText(a?.file_name).localeCompare(
      toSortableText(b?.file_name),
      "ko",
    );
  });
}
